import React, { useState } from 'react';
import {
  Button,
  FormLabel,
  Heading,
  Input,
  Modal,
} from '@alefeducation/ui-elements-library-core';
import { Times } from '@alefeducation/ui-elements-library-icons';
import styled from 'styled-components';
import appLocalStorage from '../../utils/AppLocalStorage';

export interface ExportCsvProps {
  header: string;
  onClose: (e: any) => void;
  onAction: (email: string) => void;
}

const ExportCsvModal = (props: ExportCsvProps) => {
  const { onClose, onAction, header } = props;
  const user = appLocalStorage.getAlefUser()?.user;
  const [email, setEmail] = useState<string>(user?.email || '');

  const onEmailChange = (e: React.FormEvent<HTMLInputElement>) => {
    setEmail(e.currentTarget.value);
  };

  const onExport = () => {
    onAction(email);
  };

  return (
    <Modal open size="medium">
      <ExportCsvContainer>
        <CloseIcon>
          <Times
            className="export-csv-modal__close-icon"
            color="primary.80"
            data-testid="close-action-modal"
            height={14}
            width={14}
            onClick={onClose}
          />
        </CloseIcon>
        <ExportModalContainer>
          <Heading color="text100" variant="heading-small" weight="bold">
            {header}
          </Heading>
          <ExportModalInput>
            <FormLabel>Email</FormLabel>
            <Input
              className="form-input"
              name="email"
              value={email}
              onChange={onEmailChange}
              data-testid="form-input-email"
            />
          </ExportModalInput>
        </ExportModalContainer>
        <ExportActionBtn>
          <Button
            variant="secondary"
            size="sm"
            data-testid="bt-export-cancel"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            data-testid="bt-export-csv"
            onClick={onExport}
            disabled={!email || email.length === 0}
          >
            Export
          </Button>
        </ExportActionBtn>
      </ExportCsvContainer>
    </Modal>
  );
};

export default ExportCsvModal;

const ExportCsvContainer = styled.div`
  padding: 16px 0 40px 0;
`;

const CloseIcon = styled.div`
  height: 14px;
  position: absolute;
  right: 15px;
  cursor: pointer;
`;

const ExportModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1px solid $break-line;
  padding: 24px 40px;
`;

const ExportModalInput = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;

  input {
    width: 500px;
  }
`;

const ExportActionBtn = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 24px 40px 0;

  button {
    width: 146px;
    height: 40px;
  }
`;
